<template>
    <div class="news-detail container">
        <div class="news-detail__container">
            <z-link
                class="news-detail__link"
                size="m"
                iconPosition="left"
                icon="arrow"
                :href="nav['back-link']"
                >{{ text.linkText }}</z-link
            >

            <date-block :date="newsDate" size="s" />
        </div>

        <section>
            <div v-if="newsData.category || newsData.type.value" class="news-detail__tags">
                <tag
                    v-if="
                        newsData.type.value === 'Пресс-релиз' ||
                            newsData.type.value === 'Press Release'
                    "
                    class="news-detail__tags-item"
                    theme="peach"
                >
                    {{ newsData.type.value }}
                </tag>
                <tag v-else class="news-detail__tags-item" theme="gray">
                    {{ newsData.type.value }}
                </tag>
                <div v-if="newsData.category">
                    <tag
                        class="news-detail__tags-item"
                        theme="gray"
                        v-for="(tag, index) in newsData.category"
                        :key="index"
                    >
                        {{ tag.value }}
                    </tag>
                </div>
            </div>

            <div class="news-detail__detail html-content" v-if="newsData.detailText">
                <vue-raw :raw="newsData.detailText" />
            </div>

            <div
                v-if="newsData.aboutCompany.value === 'Y'"
                class="news-detail__text news-detail__text-bg news-detail__text-bg--white u-bottom-margin--xl"
            >
                <h2 class="news-detail__text news-detail__text--accent u-bottom-margin--xs">
                    {{ text.aboutCompanyTitle }}
                </h2>
                <p>{{ text.aboutCompany }}</p>
            </div>

            <div class="u-bottom-margin--xl">
                <h2 class="news-detail__title u-bottom-margin--m">{{ text.contactsTitle }}</h2>
                <z-contact-card photo="/images/people/_.jpeg" :title="text.contacts.title" :subtitle="text.contacts.desc" :phone="phone" :email="email"/>
            </div>
        </section>

        <div class="news-detail__footer">
            <z-link
                class="news-detail__link"
                size="m"
                iconPosition="left"
                icon="arrow"
                :href="nav['back-link']"
                >{{ text.linkText }}</z-link
            >
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import { text } from './constans'

export default {
    name: 'news-detail-page',
    data () {
        return {
            newsData: {},
            nav: {},
            text,
            phone: [
                {
                    text: '+7 (3843) 99-78-92',
                    value: '+73843997892'
                },
                {
                    text: '+7 (960) 908-01-72',
                    value: '+79609080172'
                }
            ],
            email: [
                {
                    text: 'Olga.Scherbakova2@raspadskaya.ru',
                    value: 'Olga.Scherbakova2@raspadskaya.ru'
                }
            ]
        }
    },
    mounted () {
        this.newsData = this.$root.app.components['news-detail'].item
        this.nav = this.$root.app.components['news-detail'].nav
        this.SetHeroTitle(this.newsData.name)
    },

    computed: {
        newsDate () {
            const date = moment.unix(this.newsData.activeFrom).format('MM/DD/YYYY')
            return date
        }
    },

    methods: {
        ...mapActions(['SetHeroTitle'])
    }
}
</script>

<style lang="scss">
.news-detail {
    &__container {
        display: flex;
        justify-content: space-between;
        margin-bottom: 48px;

        @media screen and(max-width: 480px) {
            flex-wrap: wrap;
        }
    }

    &__detail {
        margin-bottom: 64px;
    }

    &__link {
        color: #15386c;
        margin-right: 10px;
        font-weight: 600;
        font-size: 20px !important;
        line-height: 27px !important;
        display: flex !important;
        align-items: center !important;

        @media screen and(max-width: 480px) {
            margin-bottom: 12px;
        }

        .z-icon {
            transform: rotate(-90deg) !important;
        }
    }

    &__tags {
        display: flex;
        flex-wrap: wrap;
        margin-bottom: $token-spacers-s;

        &-item:not(:last-child) {
            margin-right: 12px;
        }

        &-item {
            margin-bottom: 12px;
        }
    }

    &__title {
        @include typo-level(L);
        color: $token-colors-black-80;
    }

    &__footer {
        padding-top: 42px;
        border-top: 1px solid $token-colors-tertiary-15;
    }
}
</style>
